import "./LoadingBlock.css";

export default function LoadingBlock({
  loading = false,
  minHeight = 0,
  rounded = "xl",
  children,
  label = "Carregando...",
}) {
  const radiusClass = rounded === "lg" ? "lb-radius-lg" : "lb-radius-xl";

  return (
    <div className={`lb-root ${radiusClass}`} style={{ minHeight }}>
      <div className={`lb-content ${loading ? "lb-content--loading" : ""}`}>
        {children}
      </div>

      {loading && (
        <div className="lb-overlay" role="status" aria-live="polite">
          <div className="lb-panel">
            <div className="lb-spinner" />
            <div className="lb-text">
              <div className="lb-title">{label}</div>
              <div className="lb-sub">Aguarde um instante</div>
            </div>
          </div>

          <div className="lb-skeletons">
            <div className="lb-skel lb-skel--w60" />
            <div className="lb-skel lb-skel--w85" />
            <div className="lb-skel lb-skel--w70" />
          </div>
        </div>
      )}
    </div>
  );
}
